import { Home, LayoutDashboard, Palette, Settings, Shapes } from 'lucide-react'

import { defineArea, defineModule } from '@/lib/module-routes'
import { CAPABILITY_PERMISSIONS, HIERARCHY_PERMISSIONS } from '@/lib/permissions'

import {
  homeRoute,
  entityDashboardRoute,
  entityFeaturesSettingsRoute,
  entitySettingsRoute,
  entityWhitelabelSettingsRoute,
} from './routes'
import { settingsRoute } from './settings-route'
import { hierarchyHomeWidgets } from './home-widgets'

const homeArea = defineArea({ id: 'home', label: 'Home sections', product: 'home' })
const settingsArea = defineArea({
  id: 'settings',
  label: 'Settings sections',
  product: 'settings',
  route: settingsRoute,
})

declare module '@/lib/module-routes' {
  interface Areas {
    home: typeof homeArea
    settings: typeof settingsArea
  }
}

export const hierarchyModule = defineModule({
  widgets: hierarchyHomeWidgets,
  routes: [
    homeRoute,
    entityDashboardRoute,
    settingsRoute,
    entitySettingsRoute,
    entityWhitelabelSettingsRoute,
    entityFeaturesSettingsRoute,
  ],
  products: [
    {
      id: 'home',
      label: 'Home',
      description: 'Overview and recent activity',
      icon: Home,
      order: 10,
      routes: [entityDashboardRoute],
    },
    {
      id: 'settings',
      label: 'Settings',
      description: 'Organization preferences',
      icon: Settings,
      order: 80,
      routes: [settingsRoute],
    },
  ],
  areas: [homeArea, settingsArea],
  sections: {
    home: [{ id: 'home', label: 'Home', order: 10 }],
    settings: [{ id: 'settings', label: 'Settings', order: 10 }],
  },
  navigation: {
    home: [
      { to: '/$entityId/dashboard', label: 'Dashboard', icon: LayoutDashboard, section: 'home', order: 10 },
    ],
    settings: [
      { to: '/$entityId/settings', label: 'General', icon: Settings, section: 'settings', order: 10 },
      {
        to: '/$entityId/settings/features',
        label: 'Features',
        icon: Shapes,
        permission: CAPABILITY_PERMISSIONS.read,
        section: 'settings',
        order: 20,
      },
      {
        to: '/$entityId/settings/whitelabel',
        label: 'Whitelabel',
        icon: Palette,
        permission: HIERARCHY_PERMISSIONS.read,
        section: 'settings',
        order: 30,
      },
    ],
  },
})
